
import { store, update } from '@/api/notices'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  components: {}
})

export default class extends Vue {
  @Prop() public model!: Record<string, any>

  rules = {
    title: [
      { required: true, message: '请输入公告标题', trigger: 'blur' }
    ],
    // eslint-disable-next-line
    redirect_type: [
      { required: true, message: '请选择跳转类型', trigger: 'blur' }
    ]
  }

  loading = false

  // validate form
  validateForm (): void {
    const el: any = this.$refs.form
    el.validate((val: boolean) => val && this.sendRequest())
  }

  // send login request
  async sendRequest () {
    this.loading = true
    const params: Record<string, any> = this.model
    try {
      if (params.id) {
        await update(params.id, params)
      } else {
        await store(params)
      }
      this.$eva.success('Submit the success!')
      this.$router.push({ name: 'notices' })
    } finally {
      this.loading = false
    }
  }
}
